import { queryOptions } from '@tanstack/react-query';
import { getWebhookTargetServerFn, listWebhookTargetsServerFn } from '@/server/functions/webhook';

export const webhookListQueryOptions = (orgSlug: string) =>
  queryOptions({
    queryKey: ['webhook-list', orgSlug],
    queryFn: () => listWebhookTargetsServerFn({ data: { orgSlug } }),
  });

export const webhookQueryOptions = (orgSlug: string, webhookTargetId: string) =>
  queryOptions({
    queryKey: ['webhook', orgSlug, webhookTargetId],
    queryFn: () => getWebhookTargetServerFn({ data: { orgSlug, webhookTargetId } }),
  });

/** Single webhook target row as returned by the server (camelCase, Date instances). */
export type WebhookTargetRow = Awaited<ReturnType<typeof getWebhookTargetServerFn>>;
